import { getOpxHostAppName } from 'mini-opx-config/lib/getOpxHostAppName';
import { outlookLiteCampaignConfigs } from '../constants/outlookLiteCampaignConfigs';
import type { MiniHostAppCampaign } from '../schema/MiniHostAppCampaign';
import type { MiniHostApps } from 'mini-opx-config/lib/types/MiniHostApps';
import { type CampaignId } from '../schema/CampaignId';

type MiniHostApp = MiniHostApps | 'default';

// Lists campaigns allowed for each host app.
const MINI_HOST_APP_CAMPAIGNS_MAP: Partial<Record<MiniHostApp, MiniHostAppCampaign[]>> = {
    outlooklite: outlookLiteCampaignConfigs,
};

// List of campaigns disabled for shadow mailboxes like Gmail
const DISABLED_CAMPAIGNS_FOR_SHADOW_MAILBOX: MiniHostAppCampaign[] = ['73', '70'];

/**
 * Returns campaigns configured for the current host app filtered by mailbox type.
 */
export const getMiniHostAppCampaigns = (isShadowMailbox: boolean): MiniHostAppCampaign[] => {
    const miniHostAppCampaigns = MINI_HOST_APP_CAMPAIGNS_MAP[getOpxHostAppName()];

    if (isShadowMailbox) {
        return miniHostAppCampaigns.filter(
            campaignId => !DISABLED_CAMPAIGNS_FOR_SHADOW_MAILBOX.includes(campaignId)
        );
    }

    return miniHostAppCampaigns;
};
